export default function WhatIsFunding() {
  return (
    <section className="py-24 bg-[#1C1C1C] relative">
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/50 to-transparent"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ¿Qué es el <span className="text-[#D4AF37]">Funding</span> en Cashflow VIP?
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="bg-[#050505]/50 p-8 rounded-xl border border-[#D4AF37]/20 hover:border-[#D4AF37]/40 transition-all duration-300">
              <div className="w-14 h-14 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-bank-card-line text-[#D4AF37] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">No es un Préstamo Propio</h3>
              <p className="text-gray-300 leading-relaxed">
                Nuestro servicio de Funding es una estrategia profesional para ayudarte a conseguir tarjetas personales y de negocio con <strong className="text-[#D4AF37]">0% APR promocional</strong>, líneas de crédito y productos bancarios estratégicos.
              </p>
            </div>

            <div className="bg-[#050505]/50 p-8 rounded-xl border border-[#D4AF37]/20 hover:border-[#D4AF37]/40 transition-all duration-300">
              <div className="w-14 h-14 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-[#D4AF37] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Una Etapa Distinta</h3>
              <p className="text-gray-300 leading-relaxed">
                El Funding es diferente a la reparación de crédito. Es la <strong className="text-[#D4AF37]">segunda etapa</strong> que viene después de tener un perfil crediticio sólido, con honorarios y procesos propios.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#D4AF37]/10 to-transparent p-10 rounded-2xl border border-[#D4AF37]/30">
            <h3 className="text-2xl font-bold text-white mb-6">
              <i className="ri-shield-check-line text-[#D4AF37] mr-3"></i>
              Requisito Importante
            </h3>
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Para acceder al servicio de Funding, necesitas tener un perfil crediticio que cumpla con ciertos estándares mínimos de aprobación.
            </p>
            <div className="bg-[#050505]/50 p-6 rounded-lg border-l-4 border-[#D4AF37]">
              <p className="text-gray-300 mb-4">
                <strong className="text-white">¿Tu perfil aún no califica?</strong>
              </p>
              <p className="text-gray-400 mb-4">
                No te preocupes. Podemos ayudarte primero con nuestro servicio de reestructuración de crédito para preparar tu perfil.
              </p>
              <a
                href="https://credit.cashflow.vip/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#D4AF37] font-semibold hover:text-[#F4D03F] transition-colors duration-300 cursor-pointer"
              >
                Conoce nuestro servicio de crédito
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
